export const ERC721 = 'erc721';
export const ERC1155 = 'erc1155';
